import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SitesService } from 'src/app/modules/shared/services/sites.service';
import { DataService } from 'src/app/modules/shared/services/data.service';
import { AuthenticationService } from 'src/app/modules/shared/services/authentication.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DashboardUtils } from 'src/app/modules/shared/DashboardUtils';
import { timer, Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-dashboard-site-grupo-gerador-page',
    templateUrl: './dashboard-site-grupo-gerador-page.component.html',
    styleUrls: ['./dashboard-site-grupo-gerador-page.component.css']
})
export class DashboardSiteGrupoGeradorPageComponent implements OnInit, OnDestroy {

    public site: any;    
    public realTimeCards: any[];
    public charts: any[];
    private refreshCardDataSubscription: Subscription;
    private refreshChartDataSubscription: Subscription;

    constructor(private route: ActivatedRoute, public authenticationService: AuthenticationService, private sitesService: SitesService, private dataService: DataService,
        private spinner: NgxSpinnerService) {
        this.realTimeCards = [];
        this.charts = [];
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.spinner.show();
            this.sitesService.get(params['id']).subscribe(response => {
                this.site = response;
                
                // 1. Cards dos Geradores
                if (this.site.grupoGeradores.length > 0) {
                    this.site.grupoGeradores[0].geradores.forEach((gerador, index) => {
                        let iconsByStatus = {};
                        iconsByStatus['0'] = "image-gerador-off";
                        iconsByStatus['1'] = "image-gerador-on";
                        iconsByStatus['2'] = "image-gerador-alarm";
                        iconsByStatus['3'] = "image-gerador-off";
                        iconsByStatus['4'] = "image-gerador-off";
                        let cardGerador = { tags: [], getIconClass: () => iconsByStatus[cardGerador.tags[0].value] ? iconsByStatus[cardGerador.tags[0].value] : 'image-gerador-off', iconWidth: "41px", getLabel: () =>  gerador.name, getValue: () => {}};
                        cardGerador.tags.push({ tag: gerador.tagStatus.tagRealTimeValue });
                        if(gerador.tagPotenciaAtiva && gerador.tagPotenciaAtiva.tagRealTimeValue) {
                            cardGerador.tags.push({ tag: gerador.tagPotenciaAtiva.tagRealTimeValue });
                        }                        
                        cardGerador.getValue = () => gerador.tagPotenciaAtiva && gerador.tagPotenciaAtiva.tagRealTimeValue && !isNaN(cardGerador.tags[1].value) ? (cardGerador.tags[1].value.toFixed(1) == -0 ? "0,0kW" : cardGerador.tags[1].value.toFixed(1).replace(/[.]/, ",") +"kW") : "-";
                        this.realTimeCards.push(cardGerador);
                    });
                }
                
                // 1. Gráficos de Potência Ativa dos Geradores
                this.site.grupoGeradores[0].geradores.forEach((gerador, index) => {        
                    if(gerador.tagPotenciaAtiva && gerador.tagPotenciaAtiva.tagHistoricalValues) {
                        let chartDemanda = DashboardUtils.buildDefaultChart("Potência Ativa do Gerador: " + gerador.name +" (kW)", gerador.tagPotenciaAtiva);
                        this.updateChart(chartDemanda);
                        this.charts.push(chartDemanda);
                    }            
                });        
                
                this.refreshCardDataSubscription = timer(0, environment.dashboard.cardUpdatePeriodSeconds * 1000).subscribe(result => { 
                    this.refreshCardData();
                });
                this.refreshChartDataSubscription = timer(0, environment.dashboard.chartUpdatePeriodSeconds * 1000).subscribe(result => { 
                    this.refreshChartData();
                });

                this.spinner.hide();
            });
        });
    }

    ngOnDestroy() {
        if(this.refreshCardDataSubscription) this.refreshCardDataSubscription.unsubscribe();
        if(this.refreshChartDataSubscription) this.refreshChartDataSubscription.unsubscribe();
    }

    refreshCardData() {
        var tags = [];
        this.realTimeCards.forEach(c => tags = tags.concat(c.tags));
        this.dataService.read({items: tags}).subscribe(response => {
            for(let i in response.data) {
                Object.assign(tags[i], response.data[i]);                
            }
        });
    };
   
    refreshChartData() {
        this.charts.forEach(chart => {            
            this.updateChart(chart);    
        });
    };

    updateChart(chartToUpdate) {
        DashboardUtils.updateChart(this.dataService, chartToUpdate);
    };
}
